// extracted by mini-css-extract-plugin
export default {"na":"RegulationRow_na_KH4uV","days":"RegulationRow_days_CTI45","maxed":"RegulationRow_maxed_p2zeZ"};